import React from "react";

import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { Typography } from "@mui/material";
import { dateFormat } from "utils";

const CommentRow = ({ row, ind }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell sx={{ cursor: "pointer" }} onClick={() => setOpen(!open)}>
          {++ind}
        </TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => setOpen(!open)}>
          {row.accessType ? "Access Granted" : "Access Revoked"}
        </TableCell>
        <TableCell sx={{ cursor: "pointer" }} onClick={() => setOpen(!open)}>
          {dateFormat(row.AddedOn)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <Typography
                    variant="h6"
                    gutterBottom
                    component="div"
                    sx={{ fontWeight: "400" }}
                  >
                    Comment
                  </Typography>
                  {row.comment}
                </div>
              </div>
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default CommentRow;
